import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClipboardCheck,
  faUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';

import {
  useListBarDeliveriesQuery,
  useListOpenBarDeliveriesQuery,
} from '../../../redux/api/barDeliveryApi';
import FormatDateTime from '../../../components/dateTime/FormatDateTime';
import BarDeliveryTypeBadge from '../BarDeliveryTypeBadge';

const ListBarDeliveries = ({ onlyOpen = false }) => {
  const eventId = useSelector((state) => state.auth.currentEvent?.id);
  const navigate = useNavigate();

  const { data: allDeliveries, isLoading: allLoading } =
    useListBarDeliveriesQuery({ eventId }, { skip: !eventId || onlyOpen });
  const { data: openDeliveries, isLoading: openLoading } =
    useListOpenBarDeliveriesQuery({ eventId }, { skip: !eventId || !onlyOpen });

  const deliveries = onlyOpen ? openDeliveries : allDeliveries;
  const isLoading = onlyOpen ? openLoading : allLoading;

  if (!eventId) {
    return (
      <div className='alert alert-warning'>Bitte zuerst ein Event wählen.</div>
    );
  }
  if (isLoading) return <p className='text-muted'>Lade Bar-Lieferungen...</p>;
  if (!deliveries) {
    return (
      <div className='alert alert-danger'>
        Fehler beim Laden der Bar-Lieferungen.
      </div>
    );
  }
  if (deliveries.length === 0) {
    return (
      <div className='alert alert-warning'>
        Keine {onlyOpen ? 'offenen ' : ''}Bar-Lieferungen gefunden.
      </div>
    );
  }

  return (
    <>
      <h4>
        {deliveries.length} {onlyOpen ? 'offene' : ''} Bar-Lieferungen
      </h4>
      <table className='table table-striped mt-4 align-middle text-start'>
        <thead>
          <tr>
            <th>Nr.</th>
            <th>Bar</th>
            <th>Partner</th>
            <th>angelegt</th>
            <th>Positionen</th>
            <th>bestätigt</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {deliveries.map((delivery) => (
            <tr key={delivery.id}>
              <td>
                {delivery.counter}
                <BarDeliveryTypeBadge
                  type={delivery.type}
                  cancelled={delivery.cancelled}
                />
              </td>
              <td>{delivery.destination_name}</td>
              <td>{delivery.partner_name}</td>
              <td>
                <FormatDateTime dateTime={delivery.created_at} />
                <div className='text-muted small'>
                  {delivery.created_by_username}
                </div>
              </td>
              <td>
                <span className='fas fa-dolly me-2' />
                {delivery.total_planned_quantity}&nbsp;
                {delivery.total_planned_quantity === 1
                  ? 'Packstück'
                  : 'Packstücke'}
                <div className='text-muted small'>
                  {delivery.articles_count} Artikel
                </div>
              </td>
              <td>
                <i
                  className={`fas fa-${delivery.confirmed ? 'check' : 'xmark'}`}
                />
              </td>
              <td>
                <button
                  className='btn btn-primary btn-sm'
                  onClick={() => navigate(`/bar-delivery/${delivery.id}`)}
                >
                  <FontAwesomeIcon
                    icon={faUpRightFromSquare}
                    className='me-2'
                  />
                  öffnen
                </button>
                {!delivery.confirmed && (
                  <button
                    className='ms-2 btn btn-info btn-sm'
                    onClick={() =>
                      navigate(`/bar-delivery/${delivery.id}/confirm`)
                    }
                  >
                    <FontAwesomeIcon icon={faClipboardCheck} className='me-2' />
                    bestätigen
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default ListBarDeliveries;
